import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';


export interface RequirementItem { 
  code: string;
  value: string;
  order: number
};

interface RequirementResponse {
  data: Array<RequirementItem>;
};

@Injectable({
  providedIn: 'root'
})
export class RequirementsTypeService {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  public get(): Observable<RequirementResponse> {
    const uri = `${environment.apiUrl}/${BackendUriUnits.API}/${BackendUriUnits.SMP}/settings/requirement`;

    return this.http.get<RequirementResponse>(uri);
  }
}
